$(document).ready(function(){
    // window.onload = function () {
    //     $('.preloader-wrapper').fadeOut(500, function(){
    //         $('.preloader-wrapper').remove();
    //     });
    // }

	$(document).on('click', '.show-sub-menu-link', function(e) {
		e.preventDefault();

		$('#menu-mainnav').find('.menu-item').removeClass('current-menu-item');

		if ($(this).parent().find('.sub-menu').css('display') == 'none') {
			$(this).parent().addClass('current-menu-item');
			$(this).parent().find('.sub-menu').show();
		} else {
			$(this).parent().removeClass('current-menu-item');
			$(this).parent().find('.sub-menu').hide();
		}
	});

	// $(".slider-landing-page").slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	dots: true
	// });
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


	$(".info-box").click(function(){
		$(this).find(".tarife-lp").toggleClass("open");
	});

	$(".nav-item.dropdown").hover(function(){
		$(".dropdown-menu").toggleClass("opened");
	})
	$(".nav-item.dropdown").click(function(){
		$(".dropdown-menu").toggleClass("opened");
	});

	
	$(".toggle-filter").click(function(){
		$(this).toggleClass("active");
		$(this).parents('form').toggleClass("active");
		$(".custom-select").select2("destroy");
		$('.custom-select').select2({
			// theme: "classic"
			minimumResultsForSearch: -1,
		});
		console.log($(this).parents('.form-edit').next());
		$(this).parents('.form-edit').next().slideToggle();
	});

	$(".toggle-details").click(function(){
		let details = $(this).parents('.bm-product').children().find(".bm-product--details");
		$(this).toggleClass("active");
		details.slideToggle();
		// $(this).parents('.form-edit').next().slideToggle();
	});

	$('.select-2').select2();

	$(".toggle-view-grid-sale").click(function()
	{
		$(this).addClass("active");
		$(this).parents().find('.bm-listing-area').addClass('active');
		$(this).parents().siblings().children().removeClass('active');
	});

	$(".toggle-view-list-sale").click(function()
	{
		$(this).addClass("active");
		$(this).parents().find('.bm-listing-area').removeClass('active');
		$(this).parents().siblings().children().removeClass('active');
	});
	
	$(".close-filter").click(function(){
		$(this).parents('form').toggleClass("active");
		console.log($(this).parents('.filter-box'));
		$(this).parents('.filter-box').slideToggle();
	});

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js